export default function findSelectedProduct(products: any, productType: string) {
    if (!products || !products.data) {
        return null;
    }

    return products.data.find((product: any) => {
        return product.metadata.productType === productType
    })
}